import validators from '@utils/validators';
import {INCIDENT_DURATION_UNIT_MINUTE, INCIDENT_DURATION_UNIT_PERCENT} from '@constants/variables';
import {getTimeDifferenceInMinutesWithOneDecimal} from '@utils/momentWrapper';

const validate = (values, props) => {
    const errors = {};

    Object.assign(errors, validators.required(values.incident_source, 'incident_source'));
    Object.assign(errors, validators.required(values.incident_type, 'incident_type'));

    if (!values.includes_all_streams) {
        Object.assign(errors, validators.required(values.report_scopes, 'report_scopes'));
    }

    if (!values.entire_duration) {
        Object.assign(errors, validators.required(values.incident_duration, 'incident_duration'));

        if (values.incident_duration_unit === INCIDENT_DURATION_UNIT_PERCENT) {
            Object.assign(errors, validators.range({
                value: values.incident_duration,
                min: 1,
                max: 100,
            }, 'incident_duration'));
        }

        if (values.incident_duration_unit === INCIDENT_DURATION_UNIT_MINUTE) {
            Object.assign(errors, validators.floatAndNumbersWithFixedDecimal({value: values.incident_duration, decimal: 1}, 'incident_duration'));
            const validationParams = {
                value: parseFloat(values.incident_duration),
                min: 0.1,
            };

            if (props.formParams.duration) {
                validationParams.max = parseFloat(props.formParams.duration);
            } else if (props.formParams.matchStarted && props.formParams.matchEnded) {
                validationParams.max = getTimeDifferenceInMinutesWithOneDecimal(
                    props.formParams.matchEnded, props.formParams.matchStarted
                );
            }
            Object.assign(errors, validators.rangeFloat(validationParams, 'incident_duration'));
        }
    }

    return errors;
};

export default validate;
